import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStepBankDetails = (state) => state.get('stepBankDetails');

const makeSelectStepBankDetails = () =>
  createSelector(selectStepBankDetails, (stepBankDetailsState) => ({
    bankTypeCode: mapWithDefault(
      stepBankDetailsState,
      () => stepBankDetailsState.getIn(['form', 'bankTypeCode']),
      ''
    ),
    country: mapWithDefault(
      stepBankDetailsState,
      () => stepBankDetailsState.getIn(['form', 'country']),
      ''
    ),
    bankCode: mapWithDefault(
      stepBankDetailsState,
      () => stepBankDetailsState.getIn(['form', 'bankCode']),
      ''
    ),
    isValidate: mapWithDefault(
      stepBankDetailsState,
      () => stepBankDetailsState.getIn(['form', 'isValidate']),
      ''
    ),
    bank: mapWithDefault(
      stepBankDetailsState,
      () => stepBankDetailsState.getIn(['form', 'bank']),
      ''
    ),
    bankAddress: mapWithDefault(
      stepBankDetailsState,
      () => stepBankDetailsState.getIn(['form', 'bankAddress']),
      ''
    ),
    bankSuburbOrCity: mapWithDefault(
      stepBankDetailsState,
      () => stepBankDetailsState.getIn(['form', 'bankSuburbOrCity']),
      ''
    ),
    bankPostcode: mapWithDefault(
      stepBankDetailsState,
      () => stepBankDetailsState.getIn(['form', 'bankPostcode']),
      ''
    ),
    bankBranch: mapWithDefault(
      stepBankDetailsState,
      () => stepBankDetailsState.getIn(['form', 'bankBranch']),
      ''
    ),
    bankAccountName: mapWithDefault(
      stepBankDetailsState,
      () => stepBankDetailsState.getIn(['form', 'bankAccountName']),
      ''
    ),
    bankAccountNumber: mapWithDefault(
      stepBankDetailsState,
      () => stepBankDetailsState.getIn(['form', 'bankAccountNumber']),
      ''
    ),
    isVerified: mapWithDefault(
      stepBankDetailsState,
      () => stepBankDetailsState.getIn(['form', 'isVerified']),
      ''
    ),
  }));

const makeSelectStepBankDetailsErrors = () =>
  createSelector(selectStepBankDetails, (stepBankDetailsState) =>
    mapWithDefault(stepBankDetailsState, () => stepBankDetailsState.get('currentStep'), [])
  );

const makeSelectBsbValidating = () =>
  createSelector(selectStepBankDetails, (stepBankDetailsState) =>
    mapWithDefault(stepBankDetailsState, () => stepBankDetailsState.get('bsbValidating'), false)
  );

const makeSelectBsbNotice = () =>
  createSelector(selectStepBankDetails, (stepBankDetailsState) =>
    mapWithDefault(stepBankDetailsState, () => stepBankDetailsState.get('showBSBNotice'), false)
  );

export {
  makeSelectStepBankDetails,
  makeSelectStepBankDetailsErrors,
  makeSelectBsbValidating,
  makeSelectBsbNotice,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepBankDetails/selectors.js